export default {
  Common: {
    Title: "Quản lý khoản phải thu",
    Placeholder: "Nhập tên khách hàng, email để tìm kiếm",
    Add: "Thêm",
    AddYCTT: "Thêm mới YCTT",
    SendPayment: "Gửi YCTT",
    PaidPayment: "Đánh dấu đã thanh toán",
    TransitionPeriod: "Chuyển đợt thu",
    PhoneNumber: "Số điện thoại",
    Send: "Gửi",
    TypeCustomer: "Là khách hàng tổ chức",
    AddTitle: "Khai báo thông tin khách hàng, số tiền phải thu và hạn thanh toán để tạo YCTT mới",
    AmisDes: "Tự động đồng bộ thông tin hóa đơn, khách hàng, công nợ,... từ AMIS Kế toán",
  },
  List: {
    Column: {
      Code: "Mã yêu cầu thanh toán",
      CustomerCode: "Mã khách hàng",
      FullName: "Tên Khách hàng",
      BirthDay: "Ngày sinh",
      Semester: "Họ kỳ",
      TotalRevenue: "Tổng tiền (VNĐ)",
      CreateDate: "Ngày tạo",
      PaymentDate: "Ngày thanh toán",
      PaymentTerm: "Hạn thanh toán",
      Status: "Trạng thái",
      Email: "Email",
      PhoneNumber: "SĐT",
      DayExpired: "Số ngày quá hạn",
      SendDate: "Ngày gửi",
      Branch: "Chi nhánh",
      BillNumber: "Số hóa đơn",
    },
    Actions: {
      SendPaymentZalo: "Gửi YCTT qua tin nhắn Zalo",
      SendPaymentEmail: "Gửi yêu cầu thanh toán cho khách hàng qua Email",
      SendPaymentSMS: "Gửi YCTT qua tin nhắn SMS",
      SendPayment: "Gửi yêu cầu thanh toán",
      DetailTimeline: "Lịch sử yêu cầu thanh toán",
      Detail: "Xem chi tiết",
      Edit: "Sửa",
      Paid: "Đánh dấu đã thanh toán",
      Delete: "Xóa",
      Duplicate: "Nhân bản đợt thu",
      Transition: "Chuyển đợt thu",
    },
  },
  CreatePopup: {
    Header: "Thêm yêu cầu thanh toán",
    MerchantColumn: {
      TaxCode: "Mã số thuế",
      Name: "Tên khách hàng",
      Code: "Mã khách hàng",
      Email: "Địa chỉ email",
      Phone: "Số điện thoại",
      Address: "Địa chỉ",
    },
    Label: {
      CmbCustomer: "Tên khách hàng",
      Attachment: "Chi tiết hóa đơn",
      Number: "Số tiền",
      Datepicker: "Hạn thanh toán",
      Description: "Nội dung",
      Period: "Đợt thu",
    },
  },
  EditPopup: {
    Header: "Chỉnh sửa yêu cầu thanh toán",
    MerchantColumn: {
      TaxCode: "Mã số thuế",
      Name: "Tên khách hàng",
      Code: "Mã khách hàng",
      Email: "Địa chỉ email",
      Phone: "Số điện thoại",
      Address: "Địa chỉ",
    },
    Label: {
      CmbCustomer: "Tên khách hàng",
      Attachment: "Chi tiết hóa đơn",
      Number: "Số tiền",
      Datepicker: "Hạn thanh toán",
      Description: "Nội dung",
      Period: "Đợt thu",
    },
  },
  Transition: {
    Header: "Chuyển đợt thu cho {0} yêu cầu thanh toán",
  },
  QuickSearch: {
    Title: "Danh sách khách hàng",
  },

  TimeLineLayout: {
    Title: "Lịch sử yêu cầu thanh toán {0}",
  },
  SendPaymentPopup: {
    Title: "Gửi YCTT cho khách hàng",
    Email: "Email",
    Zalo: "Zalo",
  },
  PaidPopup: {
    Title: "Đánh dấu yêu cầu thanh toán đã được thanh toán",
  },
  DetailPopup: {
    Title: "Chi tiết yêu cầu thanh toán {0}",
    TitleGrid: "Thông tin hàng tiền",
    Column: {
      IncludeInvoice: "Lập kèm hoá đơn",
      IsOutward: "Kiêm phiếu xuất kho",
      Code: "Mã hàng",
      Name: "Tên hàng",
      UnitName: "ĐVT",
      Quantity: "Số lượng",
      UnitPrice: "Đơn giá",
      TotalAmount: "Tổng tiền",
    },
    IsSaveVoucherTextP1: "Đã sinh đề nghị",
    IsSaveVoucherTextP2: "lập chứng từ bán hàng",
  },
  DeletePopup: {
    Title: 'Xoá yêu cầu thanh toán "{0}"?',
  },
  SyncAmisPopup: {
    Title: "YCTT từ AMIS Kế toán",
    SyncSuccess: "Thêm mới thành công {0} yêu cầu thanh toán!",
    ErrorNotFound: "Chưa có dữ liệu mới từ Amis Kế Toán để đồng bộ!",
    ErrotAtLeast: "Vui lòng chọn ít nhất một yêu cầu thanh toán!",
    InActive: "Vui lòng kết nối AMIS kế toán để sử dụng dịch vụ",
    BtnSync: "Lấy dữ liệu",
  },
  Tooltip: {
    Code: "Mã yêu cầu thanh toán",
    Name: "Tên khách hàng",
    Email: "Email",
    Status: "Trạng thái",
    TotalAmount: "Tổng tiền",
    CreatedDate: "Ngày tạo",
    SendDate: "Ngày gửi",
    PaymentDate: "Ngày thanh toán",
    DueDate: "Hạn thanh toán",
    DayExpired: "Ngày hết hạn",
    UnitName: "Đơn vị tính",
  },
  ErrorMessage: {
    E1012: "Không kết nối được với Amis, vui lòng kết nối lại.",
  },
};
